export const Config = {
    host: process.env.REACT_APP_HOST || window.location.protocol + '//' + window.location.hostname,
    // Die API-URL kommt primär aus den Build-Args (REACT_APP_API_ROOT),
    // Fallback-Werte basieren auf dem aktuellen Hostname
    apiRoot: process.env.REACT_APP_API_ROOT || 
             (window.location.hostname === 'localhost' 
              ? 'http://localhost:25566/api' 
              : window.location.protocol + '//' + window.location.hostname + ':25566/api'),
    timeout: 10000
}

// Debug logging
console.log('[CONFIG-DEBUG] Frontend Config:', {
    host: Config.host,
    apiRoot: Config.apiRoot,
    env: {
        REACT_APP_API_ROOT: process.env.REACT_APP_API_ROOT,
        NODE_ENV: process.env.NODE_ENV,
        REACT_APP_HOST: process.env.REACT_APP_HOST
    }
});
